export const apiUrl = `${window.location.origin}/api`;
//export const apiUrl = 'http://127.0.0.1:30000/api';
export const appName = 'Plataforma de Control de Personal Técnico';
export const appVersion = '0.1.1';
export const appEntidad = 'Gobierno Regional de Cusco';
export const appEntidadUrl = 'https://consachapi.com/';
